const _set = (key, value) => {
  localStorage.setItem(key, JSON.stringify(value));
  return _get(key);
};

const _get = (key) => {
  const item = localStorage.getItem(key);
  return item ? JSON.parse(item) : null;
};

const _del = (key) => {
  localStorage.removeItem(key);
};

export default {
  set: _set,
  get: _get,
  del: _del,
};
